var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"py-2 px-4 text-xl focus:outline-none border-b-2 transition-all",class:{
    'text-gray-800 font-bold     border-gray-700': _vm.isSelected,
    'text-gray-500 font-semibold border-gray-200': !_vm.isSelected,
  },on:{"click":function($event){return _vm.$emit('input', _vm.tabIndex)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }